import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./ApplianceTitleStyles";
import Disc from "./Disc";

export default class ApplianceTitle extends Component {
  render() {
    const { name, appliance_type_id, app } = this.props;

    return (
      <div>
        <div className={css(styles.titleWrapper)}>
          <div className={css(styles.discWrapper)}>
            <Disc {...this.props} size="noDisc" />
          </div>
          <div className={css(styles.textContainer)}>
            <span className={css(styles.applianceTitle)}>{name}</span>
            {this.props.status.state === "on" ? (
              <p className={css(styles.pastHour)}>
                <span className={css(styles.onHightlight)}>On</span> in the past
                hour
              </p>
            ) : null}
          </div>
        </div>
        <div className={css(styles.editWrapper)}>
          <a
            href={`/account/${app}/appliance/${appliance_type_id}`}
            className={css(styles.edit)}
          >
            <img className={css(styles.editImg)} src="/icons/pencil.svg" />
            Edit Appliance
          </a>
        </div>
      </div>
    );
  }
}
